import {
  RelatedLinksFields,
  RelatedLinksProps,
} from "../types/RelatedLinks.types";

export class RelatedLinksModel {
  private readonly fields?: RelatedLinksFields;

  constructor(props: RelatedLinksProps) {
    this.fields = props.fields;
  }
}
